<div class="logos-wrapper">
  <div [ngClass]="{ 'logos-container-static': imageUrls?.length <= MAX_LOGOS, 'logos-container-animated': imageUrls?.length > MAX_LOGOS, 'mobile-display-static d-flex justify-content-center': imageUrls?.length < MIN_LOGOS }">
    <div data-test="carousel-primary" class="carousel">
      <img *ngFor="let imageUrl of imageUrls" [src]="imageUrl" [style.width.px]="getNormalizedImageWidth(imageUrl)"/> 
    </div>
    <div data-test="carousel-secondary" class="carousel" [ngClass]="{ 'd-lg-none': imageUrls?.length <= MAX_LOGOS, 'd-none': imageUrls?.length < MIN_LOGOS }">
      <img *ngFor="let imageUrl of imageUrls" 
           [src]="imageUrl" 
           [style.width.px]="getNormalizedImageWidth(imageUrl)"
           />
    </div>
  </div>
</div>
